<template>
  <section class="platform-preview-access" role="status">
    <p>{{ error || '正在读取项目预览…' }}</p>
    <el-button v-if="error" @click="load">重新加载</el-button>
  </section>
</template>
<script>
import { getObj1 } from '@/api/visual'
import { readPageProject } from '@/schema/page-project'
import { createPreviewSnapshot } from '@/runtime/preview-snapshot'
export default {
  data: () => ({ error: '' }),
  created() {
    this.load()
  },
  methods: {
    async load() {
      this.error = ''
      const id = this.$route.params.id
      try {
        const response = await getObj1(id),
          record = response.data?.result
        if (
          this._isDestroyed ||
          this.$route.name !== 'platform-project-preview' ||
          this.$route.params.id !== id
        )
          return
        if (!record || record.id !== id || !['big_screen', 'scada2d'].includes(record.type))
          throw new Error('项目预览数据无效')
        const model = readPageProject(record)
        const preview = createPreviewSnapshot(
          record,
          { ...model.metadata, pageProject: model.pageProject },
          model.config,
          model.nodes
        )
        await this.$router.replace({ name: 'view', params: { id }, query: { preview } })
      } catch (e) {
        if (!this._isDestroyed) this.error = e.message || '预览失败，请重试'
      }
    }
  }
}
</script>
<style scoped>
.platform-preview-access {
  padding: 32px;
  min-height: 100vh;
  background: #f5f7fa;
  color: #475467;
  box-sizing: border-box;
}
</style>
